import { bridgeApi } from '../network'

export async function getCustomerCount() {
  const { data } = await bridgeApi.get('/enterprise/subAgent/getCustomerCount')
  return data
}

export async function getHomePageTopBrand({
  categoryIds = [],
}: {
  categoryIds?: string[]
}) {
  console.log(categoryIds)
  const { data } = await bridgeApi.get(
    categoryIds.length
      ? `/enterprise/subAgent/getHomePageTopBrand?categoryIds=${categoryIds?.join(
          ','
        )}`
      : '/enterprise/subAgent/getHomePageTopBrand'
  )
  return data
}

export async function getLeadCount({ categoryId }: { categoryId?: string }) {
  const { data } = await bridgeApi.get(
    `/enterprise/subAgent/getLeadCount?category=${categoryId}`
  )
  return data
}
